<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>

                <CCardHeader class="p-1">
                  <CRow>
                    <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                      <strong>{{$t('visitorRoute')}}</strong>

                    </CCol>
                    <CCol col="4" style="text-align: end">


                      <CButton  @click="insert_data()" class="mr-1 ml-1"  type="submit" size="sm"
                               color="secondary">
                        {{ $t('buttons.submit') }}
                      </CButton>

                      <CButton
                          class="mr-1"
                          size="sm"
                          color="secondary"
                      >{{ $t("buttons.cancel") }}
                      </CButton>

                    </CCol>
                  </CRow>
                </CCardHeader>

                <CCardBody>
                  <CRow>
                    <CCol col="3">
                      <CSelect
                          :label="$t('route')"
                          horizontal
                          :value.sync=selected_driver_route
                          :options="driver_route_items"
                      />

                    </CCol>

                    <CCol col="3">
                      <CRow form class="form-group">
                        <CCol tag="label" sm="3" class="col-form-label">
                          {{$t('visitor')}}
                        </CCol>
                        <CCol sm="9">
                          <treeselect
                              v-model="document_person"
:options="static_user_names"
                              :async="static_user_state"
                              :load-options="load_persons"
                              :placeholder="$t('components.searchUser')"
                              :normalizer="normalizer_persons"
                          />
                        </CCol>
                      </CRow>
                    </CCol>

                    <CCol col="2">
                      <CSelect :options="[{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:0}]"
                               :value.sync="selected_status"
                      />

                    </CCol>


                  </CRow>


                </CCardBody>
                <CCard>
                  <CCardHeader>
                    <strong>{{$t('routes')}}</strong>
                  </CCardHeader>
                  <CCardBody>
                    <CDataTable
                        :items="driver_items"
                        :fields="fields_driver"
                        @row-clicked="table_row_clicked"
striped
                        border
                        :items-per-page="20"
                        hover
                        sorter
                        pagination
                    >
                      <template v-slot:[item_row_name]="{item}">

                          <td style="text-align: center">
                          <p >{{ item.row_id + 1 }}</p>

                        </td>

                      </template>
                      <template #user="{item}">

                        <td>
                          <p >{{ item.personName }}</p>

                        </td>

                      </template>


                      <template #vehicle="{item}">

                        <td>
                          <p >{{ item.carType }} {{ item.carName }}</p>

                        </td>

                      </template>

                      <template #tag="{item}">

                        <td>
                          <p >{{ item.carPelak }}</p>

                        </td>

                      </template>

                      <template #weight="{item}">

                        <td>
                          <p >{{ item.mizanBar }} {{ $t('components.weightUnit') }}</p>

                        </td>

                      </template>
<template #isActive="{item}">

                        <td>
                          <p v-if="item.isActive==1">{{ $t('active') }}</p>
                          <p v-if="item.isActive==0">{{ $t('deactivate') }}</p>

                        </td>

                      </template>


                      <template #operation="{item}">
                        <td >


<!--                          <CButton-->
<!--                              color="warning"-->
<!--                              variant="outline"-->
<!--                              square-->
<!--                              size="sm"-->
<!--                              @click="edit_item_driver(item)"-->
<!--                          ><CIcon name="cil-pencil" />-->
<!--                          </CButton>-->
                          <CButton class="mr-1"
                                   square
                                   :title="$t('buttons.delete')"
                                   size="sm"
                                   @click="delete_driver_dialog(item)"
                          >
                            <CIcon name="cilTrash" size="sm" class="text-danger"/>
                          </CButton>
<!--                          <CButton-->
<!--                              color="danger"-->
<!--                              variant="outline"-->
<!--                              square-->
<!--                              size="sm"-->
<!--                              @click="delete_driver_dialog(item)"-->
<!--                          ><CIcon name="cil-trash" />-->
<!--                          </CButton>-->


                        </td>
                      </template>


                    </CDataTable>
                  </CCardBody>
                  <CCardFooter>

                  </CCardFooter>
                </CCard>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
import Vue from "vue";

var simulateAsync=null
const simulateAsyncOperation = fn => {
    if(simulateAsync!=null){
        clearTimeout(simulateAsync)
    }
    simulateAsync =  setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    BTabs,
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      collapse: false,
      validate_errors: [],
      route_name: '',
      route_code: '',
      person_name: '',
      person_mobile: '',
      car_pelak: '',
      car_type: 0,
      car_name: 0,
      car_title: '',
      mizan_bar: '',
      car_volume: '',
      item_row_name: 'row',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      car_items: [],
      route_items: [],
      route_sub_items: [],
      route_sub_items_temporary: [{province:'',city:'',district:'',area:''}],
      driver_items: [],
      fields_driver: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'routeTitle', label: this.$t('route'), _style: 'width:10%'},
        {key: 'salesManTitle', label:this.$t('visitor'), _style: 'width:15%'},
        // {key: 'vehicle', label: this.$t('tables.vehicle'), _style: 'width:15%'},

        // {key: 'user', label: this.$t('visitor'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('components.status'), _style: 'width:10%'},

        // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},


      ],

      car_type_items: [],

      car_name_items: [],

      selected_driver_car:0,
      driver_car_items: [],
      selected_driver_route:0,
      driver_route_items: [],

      document_person: null,

      area_items: [],
      selected_area: 0,

      static_user_names2: [],
      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,
      table_clicks_timer:null,
      table_clicks:0,
      details: [],
      selected_status:1,
      collapseDuration: 0,
      // status_form: 0,
      status_form_car: 0,
      status_form_route: 0,
      status_form_driver: 0,
      inline_status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.fullName,
        }
      },
      static_user_names:[],
      static_user_state:true,
    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_route_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_driver_item();

      } else {
        this.status_form_driver = 0;
      }
    });
  },
  watch: {
    'document_person': function () {
      this.get_lists();
    },

  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item_driver(item)
        this.table_clicks = 0
      }

    },

    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != null ) {
        return true;
      }


      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.selected_driver_route == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectRoute'));
      }


      return false;
      // e.preventDefault();
    },

    edit_item_driver(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      // {"data":[{,"weight":1200022.00,"volume":300022.00,"id":1,"carTitle":"پراید 131","carType":"سواری"}],"isSuccess":true,"statusCode":0,"message":"عملیات با موفقیت انجام شد"}

      this.static_user_names=[{userId:item.salesManId,fullName:item.salesManTitle}]

      this.document_person = item.salesManId
      this.selected_driver_route = item.routeId
      this.selected_status = item.isActive
      // this.static_user_names=[{userId:item.personId,userName:item.personName}]
      this.static_user_state= false

       setTimeout(() => {
        this.static_user_state= true

      }, 500);

      this.status_form_driver = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    get_route_lists() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.driver_route_items = self.sort_array(
                  self.driver_route_items, content_data.data,
                  'id','title');

          self.selected_driver_route = self.driver_route_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goSubCategories(item) {

      this.$router.push({path: '/dashboard/delivery/driver-documents/' + item.personId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    get_user_data() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.document_person);


      axios.post('GetPersonById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.person_mobile = content_data.data.mobileNo;
          self.person_name = content_data.data.personName;
          // self.province_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form_driver == 0) {
        url = "AddSalesManRoute";
      } else {
        url = "EditSalesManRoute";
        formData.append('Id', this.status_form_driver)

      }

      formData.append('SalesManId', this.document_person);
      // formData.append('SalesManTitle', this.selected_driver_car);
      formData.append('RouteId', this.selected_driver_route);
      // formData.append('RouteTitle', this.selected_driver_route);
      formData.append('IsActive', this.selected_status);
      formData.append('RecSummary', '');

      axios.post(url, formData, {}).then((res) => {

        self.status_form_driver = 0;

        self.selected_driver_route = 0;
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetSalesManRoutesById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.driver_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    delete_driver_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.status_form_driver = item.id;
    },
    delete_driver_item() {
      let self = this;
      const formData = new FormData()
      let url;

      url = "DeleteSalesManRoute";
      formData.append('id', this.status_form_driver);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form_driver = 0;
        self.get_driver_lists();
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}

</script>
